export default __webpack_public_path__ + "static/media/eye_white.299b4af6.svg";